import { type Localisation } from "./en";

export const portuguese: Localisation = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    hoursMinutes: "HH:mm",
    dateDay: "eeee do",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "A tela está ativa, mas nenhum token está presente",
    "Network error": "Erro de rede",
    "Checking display status": "Verificando o status de exibição",
    "Failed to get display status": "Falha ao obter o status de exibição",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "Se o problema persistir, entre em contacto com o administrador do Teamworks.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "Isto deve-se geralmente a um erro de rede ao configurar o dispositivo. Redefina o dispositivo utilizando o botão abaixo e tente novamente.",
    "Setup failed to complete": "A configuração não foi concluída",
    "Please reset your device using the button below and try again.":
      "Redefina o dispositivo utilizando o botão abaixo e tente novamente.",
  },
  ConfigProvider: {
    "Loading configuration": "Carregando configuração",
  },
  AppProvider: {
    Loading: "Carregando",
    "No configuration selected": "Nenhuma configuração selecionada",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "Não foi possível encontrar uma configuração para o código fornecido. Entre em contato com o administrador do Teamworks.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "Este dispositivo foi registrado, mas nenhuma configuração foi definida ainda. Não se preocupe, você pode atualizar facilmente este dispositivo no aplicativo de gerenciamento de monitores digitais.",
    "Network error: failed to load playlist":
      "Erro de rede: falha ao carregar a lista de reprodução",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "Resetting, please wait...": "Redefinindo, por favor aguarde...",
  },
  UpdatesProvider: {
    "Checking for update": "Verificando atualizações",
    "Downloading update": "Baixando atualização",
  },
  InteractionScreen: {
    "Loading...": "Carregando...",
    "Press any key to begin": "Pressione qualquer tecla para começar",
    "No configurations assigned": "Nenhuma configuração atribuída",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "Você pode atribuir uma configuração ou uma lista de reprodução para execução neste dispositivo no aplicativo de gerenciamento de Displays Digitais.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app":
      "Digitalize o código QR no aplicativo da câmera",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}":
      "Página de eventos {{count}} de {{total}}",
    Today: "Hoje",
    "All day": "O dia todo",
    Tomorrow: "Amanhã",
  },
  ErrorScreen: {
    "Something went wrong": "Algo deu errado",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Desculpe pela inconveniência, nossos engenheiros foram notificados e estarão trabalhando em uma correção",
    "If this issue persists, please contact your account manager":
      "Se o problema persistir, entre em contato com seu gerente de conta",
    "Reset device": "Redefinir dispositivo",
    "Your IP address may need to be permitted: {{ip}}":
      "O seu endereço IP pode precisar de ser permitido: {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "A aplicação tentará redefinir automaticamente em {{seconds}} segundos",
  },
  NextMatch: {
    days: "dias",
    hours: "horas",
    minutes: "minutos",
    seconds: "segundos",
  },
  MediaContentCarosel: {
    "Media not found": "Mídia não encontrada",
  },
  PlaylistProvider: {
    "Loading...": "A carregar...",
    "Loading playlist": "A carregar a lista de reprodução",
  },
  ScreenFooter: {
    Hardcoded: "Codificado",
  },
  NotFoundLayout: {
    "Configuration not found": "Configuração não encontrada",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "Nenhum treino selecionado",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Selecione um treino no separador Digital Display em S&C para o mostrar aqui",
  },
  WeatherWidget: {
    "Weather unavailable": "Tempo indisponível",
  },
  NutritionMenu: {
    "Failed to fetch menu": "Falha ao buscar o menu",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station": "Falha ao buscar a estação de refeições",
    "Add ons will affect nutrition information":
      "Os complementos afetarão as informações nutricionais",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "Sem dados meteorológicos para mostrar, entre em contato com o administrador do Teamworks.",
    Clear: "Limpo",
    Clouds: "Nublado",
    Rain: "Chuva",
    Drizzle: "Chuvisco",
    Thunderstorm: "Trovoada",
    Snow: "Neve",
    Mist: "Nevoeiro",
    Smoke: "Fumo",
    Haze: "Neblina",
    Dust: "Poeira",
    Fog: "Nevoeiro denso",
    Sand: "Areia",
    Ash: "Cinza vulcânica",
    Squall: "Rajada",
    Tornado: "Tornado",
  },
};
